import React from 'react'

function Checkbox(props) {
    const handleChange = () => props.onChange(props.name, !props.value)
    return (
        <div className="display--flex align-items--center gap--8">
            {
                props.value != false ?
                    <input id={props.name} defaultChecked={true} name={props.name} type="checkbox" onChange={handleChange} />
                    :
                    <input id={props.name} type="checkbox" onClick={handleChange} />
            }
            <label htmlFor={props.name} style={{ cursor: 'pointer', fontSize: '14px', marginLeft: '8px' }}>{props.display}</label>
        </div>
    )
}

export default Checkbox;